import {
  parseDataForDisplay,
  parseDataForList,
} from 'lib/NewQueryByMultimarket';
import session from 'lib/session';
import { createReducer, field } from 'redux/shelf';
import { del, get, post, put } from 'redux/shelf/api';

export const actions = {
  fetchAll: get`merchandise/${session.getMerchant}`(parseDataForList),
  fetch: get`merchandise/${session.getMerchant}/:id`(parseDataForDisplay),
  update: put`merchandise/${session.getMerchant}/:id`(),
  create: post`merchandise/${session.getMerchant}`(),
  remove: del`merchandise/${session.getMerchant}/:id`(),
  getFields: get`fields/${session.getMerchant}`(field('fields')),
  getDefaultSearch: get`default-search-merchandise/${session.getMerchant}`(
    field('default')
  ),
  getDefaultCollection:
    get`default-collection-merchandise/${session.getMerchant}`(
      field('default')
    ),
  getDefaultRecommendation:
    get`default-recommendations-merchandise/${session.getMerchant}`(
      field('default')
    ),
  setDefaultSearch: put`default-search-merchandise/${session.getMerchant}`(
    field('default')
  ),
  setDefaultCollection:
    put`default-collection-merchandise/${session.getMerchant}`(
      field('default')
    ),
  setDefaultRecommendation:
    put`default-recommendations-merchandise/${session.getMerchant}`(
      field('default')
    ),
};

export const reducer = createReducer(actions, {
  [actions.remove]: (s, { meta }) => ({
    ...s,
    entities: s.entities.filter((item, i) => item.id !== meta.id),
  }),
  [actions.update]: (s, { meta }) => {
    return {
      ...s,
      entities: [
        ...s.entities.map((entity, i) =>
          entity.id !== meta.id ? entity : meta
        ),
      ],
    };
  },
});

export enum RuleType {
  collection = 'collection',
  recommendation = 'recommendation',
  search = 'search',
}

const defaultRulesDescription = {
  [RuleType.search]:
    "These rules will be applied by default to all search queries if they don't have any merchandising rules set up",
  [RuleType.collection]:
    "These rules will be applied by default to all collections if they don't have any merchandising rules set up",
  [RuleType.recommendation]:
    "These rules will be applied by default to all recommendation widgets if they don't have any merchandising rules set up",
};

export const getDefaultRuleDescription = (type: RuleType) =>
  defaultRulesDescription[type];
